<template>
    <div>

        <div slot="header"><strong style="font-size: 16px">Area Group ({{areaGroupArr.length}})</strong>
            <Icon type="md-add-circle" class="add-icon-area" @click="onAddAreaGroup"></Icon>
        </div>
        <div>
            <Table :columns="areaGroupHeaders" :data="areaGroupArr" ref="areaGroupTable" :highlight-row="true"
                   @on-row-click="emitAreaGroup" max-height="400">
                <template slot-scope="{ row }" slot="action">
                    <!--<Icon type="md-create" @click="onEditAreaGroup(row)"></Icon>&nbsp;-->
                    <Icon type="md-close" @click="onDeleteAreaGroup(row.id)"></Icon>
                </template>
            </Table>
        </div>


        <Modal v-model="addAreaGroupDialog" :mask-closable="false" width="450" draggable>
            <div slot="header"><strong>{{editMode?'Edit':'New'}} Area Group</strong></div>
            <div>
                <Form :model="areaGroupForm" :rules="ruleAreaGroupForm" ref="areaGroupForm" :label-width="110">
                    <FormItem prop="name" label="Area Group">
                        <Input v-model="areaGroupForm.name"/>
                    </FormItem>

                    <FormItem prop="cityName" label="City">
                        <AutoComplete v-model="areaGroupForm.cityName">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div" @click="areaGroupForm.cityId=cityObj.id">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addAreaGroup" :loading="loading">
                    <span v-if="!loading">SAVE</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyAreaGroup">UPDATE</Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="addAreaGroupDialog=false">CANCEL</Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import {ADD_AREAGROUP, UPDATE_AREAGROUP, DELETE_AREAGROUP} from '../../graphql/mutations/areaGroup'
import { SEARCH_CITY2} from '../../graphql/queries/territories'
import {GET_AREAGROUPS} from '../../graphql/queries/areaGroup'
import {SUBSCRIBE_GET_AREAGROUPS} from '../../graphql/subscription/areaGroup'
import {generateUUID} from '../../Constants/Constant'
import ValidationRules from '../../Constants/ValidationRules'
    export default {
        apollo: {
            areaGroups: {
                query: GET_AREAGROUPS,
                variables() {
                    return {
                        cityId: this.city.id
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_GET_AREAGROUPS,
                    variables() {
                        return {
                            cityId: this.city.id
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.areaGroupArr = subscriptionData.data.areaGroups;
                    },
                },
                prefetch: false,
                result ({ data, loading }) {
                    if (!loading) {
                        this.areaGroupArr = data.areaGroups;
                    }
                }
            },
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.cityArr = data.city;
                    }
                }
            },
        },
        name: "AreaGroup",
        props:['city'],
        data: function(){
            return{
                mutation_ADD_AREAGROUP: ADD_AREAGROUP,
                mutation_UPDATE_AREAGROUP: UPDATE_AREAGROUP,
                mutation_DELETE_AREAGROUP: DELETE_AREAGROUP,
                areaGroupArr: [],
                areaGroupHeaders: [
                    {title: 'AreaGroup', key: 'name'},
                    {title: ' ', slot: 'action'}
                ],
                areaGroupForm:{
                    id: '',
                    name: '',
                    cityId: '',
                    cityName: ''
                },
                cityArr: [],
                ruleAreaGroupForm:{name: ValidationRules.textField('Name')},
                addPopover: false,
                editPopover: {},
                selectedIndex: '',
                addAreaGroupDialog: false,
                editMode: false,
                loading: false
            }
        },
        computed: {
            cityFilter () {
                return '%' + this.areaGroupForm.cityName + '%'
            },
        },
        methods:{
            onAddAreaGroup(){
                this.areaGroupForm.name = '';
                this.areaGroupForm.cityId = this.city.id;
                this.areaGroupForm.cityName = this.city.city;
                this.editMode = false;
                this.addAreaGroupDialog = true;
            },
            emitAreaGroup(row, index){
                this.$emit('areaGroup', row)
            },
            reset: function(){
                this.$refs['areaGroupForm'].resetFields();
            },
            addAreaGroup(){
                this.loading = true;
                this.$refs['areaGroupForm'].validate((valid) => {
                    if (valid) {
                        this.insertareaGroup();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertareaGroup(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_AREAGROUP,
                    variables: {
                        id: generateUUID(),
                        name: this.areaGroupForm.name,
                        cityId: this.areaGroupForm.cityId

                    }
                })
                if(response.data.insert_areaGroups.returning[0].id){
                    this.$Message.success('New Area Group added successfully!');
                    this.reset();
                    this.loading = false
                    this.addAreaGroupDialog = false;
                }
            },
            onEditAreaGroup(areaGroupData){
                this.areaGroupForm.id = areaGroupData.id;
                this.areaGroupForm.name = areaGroupData.name;
                this.areaGroupForm.cityId = areaGroupData.cityId;
                this.areaGroupForm.cityName = areaGroupData.City.city;
                this.editMode = true;
                this.addAreaGroupDialog = true;
            },
            modifyAreaGroup(){
                this.$refs['areaGroupForm'].validate((valid) => {
                    if (valid) {
                        this.updateAreaGroup();
                    }
                })
            },
            async updateAreaGroup(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_AREAGROUP,
                    variables: {
                        areaGroupId: this.areaGroupForm.id,
                        name: this.areaGroupForm.name,
                        cityId: this.areaGroupForm.cityId
                    }
                })
                if(response.data){
                    this.$Message.success('AreaGroup updated successfully!');
                    this.reset();
                    this.addAreaGroupDialog = false;
                }
            },
            onDeleteAreaGroup(areaGroupId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete AreaGroup ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteAreaGroup(areaGroupId, this.$Modal)
                    }
                });
            },
            deleteAreaGroup(areaGroupId, callback){
                var self = this;
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_AREAGROUP,
                    variables: { areaGroupId: areaGroupId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('AreaGroup deleted successfully!');
                }).catch(function(err){
                    if(err.networkError.result.errors && err.networkError.result.errors.length
                    && err.networkError.result.errors[0].message.substring(21, 0) === 'Foreign key violation'){
                        self.$Notice.error(
                            {title: err.networkError.response.statusText,
                                desc: 'Cannot delete AreaGroup because other data depends on it'});}
                    callback.remove();
                })
            }
        },
        mounted(){}
    }
</script>

<style scoped>
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
    .poptip-cancel-btn{
        background: #999999;
        color: white;
        font-weight: bolder;
        float: right;
        margin-left: 4px;
    }
    .poptip-save-btn{
        font-weight: bolder;
        float: right
    }
    .add-icon-area{
        float: right;
        font-size: 22px;
    }
</style>